interface IControllerOptions {
  signal: AbortSignal;
}

/** Принимает коллбэк, делэй и сигнал аборт контроллера для сброса таймера. */
export const promisifiedTimeout = (cb: VoidFunction, delay: number, { signal }: IControllerOptions) => {
  return new Promise((res, rej) => {
    if (signal?.aborted) {
      return rej(signal?.reason);
    }

    const timeoutId = setTimeout(() => res(cb()), delay);

    signal?.addEventListener('abort', () => {
      clearTimeout(timeoutId);
      rej(signal?.reason);
    });
  });
};
